import { lazy } from 'react';
import { Redirect } from 'react-router-dom';
// guards
import AuthGuard from '../guards/AuthGuard';
// layouts
import DashboardLayout from '../layouts/dashboard';
//
import { PATH_ADMIN } from './paths';

// ----------------------------------------------------------------------

const AdminRoutes = {
  path: PATH_ADMIN.root,
  guard: AuthGuard,
  layout: DashboardLayout,
  routes: [
    {
      exact: true,
      path: PATH_ADMIN.teams.teams,
      component: lazy(() => import('../views/admin/Teams'))
    },
    {
      exact: true,
      path: PATH_ADMIN.users.users,
      component: lazy(() => import('../views/admin/Users'))
    },
    {
      exact: true,
      path: PATH_ADMIN.settings.settings,
      component: lazy(() => import('../views/admin/Settings'))
    },
    {
      exact: true,
      path: PATH_ADMIN.data_redaction.data_redaction,
      component: lazy(() => import('../views/admin/DataRedaction'))
    },
    {
      exact: true,
      path: PATH_ADMIN.data_redaction.view,
      component: lazy(() => import('../views/admin/data_redaction/ViewDataRedaction'))
    },
    {
      exact: true,
      path: PATH_ADMIN.data_redaction.create,
      component: lazy(() => import('../views/admin/data_redaction/UpdateDataRedaction'))
    },
    {
      exact: true,
      path: PATH_ADMIN.data_redaction.edit,
      component: lazy(() => import('../views/admin/data_redaction/UpdateDataRedaction'))
    },
    // ----------------------------------------------------------------------

    {
      component: () => <Redirect to="/404" />
    }    
  ]
};

export default AdminRoutes;
